export default "__VITE_ASSET__B_x_Vz9Q__"